import { render, staticRenderFns } from "./Renewal_InfoPremises.vue?vue&type=template&id=1400f5f6&scoped=true&"
import script from "./Renewal_InfoPremises.vue?vue&type=script&lang=js&"
export * from "./Renewal_InfoPremises.vue?vue&type=script&lang=js&"
import style0 from "./Renewal_InfoPremises.vue?vue&type=style&index=0&id=1400f5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400f5f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VIcon,VRadio,VRadioGroup,VSelect,VTextField,VTooltip})
